// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-heading-wrap .section-title {
  margin-bottom: 16px;
}
.page-heading-wrap .section-intro *:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/PageHeading/PageHeading.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGQ;EACI,gBAAA;AADZ","sourcesContent":[".page-heading-wrap {\n    .section-title {\n        margin-bottom: 16px;\n    }\n    .section-intro {\n        *:last-child {\n            margin-bottom: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
